import pcLogo from '../../../public/images/icon.png';

export const DiscordBot = () => {
  return (
    <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
      <div className='bg-hero bg-content text-content-text m-0 h-auto w-full bg-cover bg-no-repeat p-0'>
        <div className='container mx-auto flex h-auto w-full flex-col items-center justify-center gap-4 px-8 py-32 text-amber-400'>
          <div className='flex flex-col items-center justify-center gap-4 rounded-lg border-2 border-[#2D618C] bg-[#0F1727] p-8'>
            <img src={pcLogo} alt='Playcast Logo' className='size-[150px]' />
            <h1 className='text-xl'>Authorized</h1>
            <p>You may now close this window or tab.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
